import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";

const SellerDashboard = () => {
  const navigate = useNavigate();
  return (
    <>
      <SEOHead
        title="Seller Dashboard - Bahama Marketplace"
        description="Manage your Bahama Marketplace store. View sales, manage products, track orders, and grow your business."
      />
      <main className="container mx-auto px-4 py-10">
        <h1 className="text-3xl font-heading font-bold mb-6">Seller Dashboard</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Button onClick={() => navigate("/seller/shop")} className="h-20 flex flex-col gap-2">
            <span className="font-semibold">Setup Shop Profile</span>
            <span className="text-xs opacity-80">Configure your store details</span>
          </Button>
          <Button variant="outline" onClick={() => navigate("/seller/products")} className="h-20 flex flex-col gap-2">
            <span className="font-semibold">Manage Products</span>
            <span className="text-xs opacity-80">Add, edit, and organize inventory</span>
          </Button>
          <Button variant="secondary" onClick={() => navigate("/seller/moderation")} className="h-20 flex flex-col gap-2">
            <span className="font-semibold">Moderation</span>
            <span className="text-xs opacity-80">Control product visibility</span>
          </Button>
          <Button variant="outline" onClick={() => navigate("/seller/analytics")} className="h-20 flex flex-col gap-2">
            <span className="font-semibold">Analytics</span>
            <span className="text-xs opacity-80">View sales performance</span>
          </Button>
        </div>
      </main>
    </>
  );
};
export default SellerDashboard;